// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__WHMtE","filesListContainer":"PosDisputesFiles_filesListContainer__3KNe5","filesButton":"PosDisputesFiles_filesButton__3jv1v"};